<template>
<div class="body">
    <div class="scrollerView" :style="{ height: (wrapperHeight) + 'px' }">
        <div class="swiper">
            <van-swipe :autoplay="5000" indicator-color="white">
                <van-swipe-item v-for="(item, index) in dataSources.shop_banner" :key="index">
                    <a :href="item.link_url">
                        <img :src="item.img_url">
                    </a>
                </van-swipe-item>
            </van-swipe>
        </div>

        <div class="menu">
            <div v-for="(item, index) in dataSources.goods_category_list" :key="index" @click="_onPressToNavigate('', 'pointGoodsList', {shop_id: 1, cate_id: item.id, cate_name: item.name})">
                <img :src="item.image" />
                <p>{{item.name}}</p>
            </div>
        </div>

        <div class="goods-list-wrap">
            <div class="list-header-wrap">
                <div class="left"></div>
                <p class="header-title">热门推荐</p>
                <div class="more" @click="_onPressToNavigate('', 'pointGoodsList')">更多 >></div>
            </div>
            <div class="list-body flex rcb">
                <point-goods-item v-for="(item, index) in dataSources.recommend_goods_list" :key="index" :item="item" />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import PointGoodsItem from '../../components/item/PointGoodsItem';
export default {
    components: {
        PointGoodsItem
    },
    data() {
        return {
            wrapperHeight: 0, //屏幕高度 - 脚部
            dataSources: {
                shop_banner: [],
                goods_category_list: [],
                recommend_goods_list: [],
            },
        };
    },
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
        this.requestData();
    },
    methods: {
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            window.location.href = url;
        },

        // 请求首页数据
        async requestData() {
            let url = this.API.point_shop_home;
            let params = {};
            let result = await this.$post(url, params);
            console.log(this.GLOBAL.SUCCESS_CODE)
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.body {
    background-color: #fff;
}

.scrollerView {
    position: relative;
    width: 100%;
    overflow-y: auto;
}

.swiper {
    height: 40vw;
    box-sizing: border-box;
    margin: 1.5rem 1.5rem;
    border-radius: 6px;
    overflow: hidden;

    img {
        height: 40vw;
        width: 100%;
        object-fit: cover;
    }
}

.menu {
    margin: 15px 15px;
    display: flex;

    div {
        width: 25%;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
            width: 40px;
            height: 40px;
            margin-bottom: 5px;
            border-radius: 20px;
            object-fit: cover;
        }

        p {
            font-size: 14px;
            color: #333;
        }
    }
}

.goods-list-wrap {
    padding: 0 1.5rem 2rem;

    .list-header-wrap {
        display: flex;
        align-items: center;

        .left {
            width: 4px;
            height: 18px;
            background: linear-gradient(225deg, #9cb2f4, #6472e8);
        }

        .header-title {
            flex: 1;
            margin: 0 10px;
            font-size: 15;
            color: #333;
        }

        .more {
            height: 2rem;
            color: #7181EB;
            padding: 0 1rem;
            font-size: 1.2rem;
            line-height: 2rem;
            border-radius: 2rem;
            background: #F1F3FF;
            border: 1px solid #7181EB;
        }
    }

    .list-body {
        display: flex;
        flex-wrap: wrap;
    }
}
</style>
